// Per-org labels for the invoice-requests module (#225).
//
// The module is shared by every cooperative, so its user-facing name is
// configurable per build via VITE_* env keys (the frontend already builds per
// org — Vite modes local[ORG]/production[ORG]; precedent: VITE_TITLE,
// VITE_SHOW_TREASURY). The defaults below reproduce the original
// "Pedido de Factura" wording, so an org that overrides nothing is byte-identical
// to before; Pro Nobis overrides them to "Comunicação de Trabalho" in its
// front/.env.localpronobis / front/.env.productionpronobis files.
//
// Most forms are derived from `singular` / `plural` (lower-case + sentence-case).
// The gendered phrases — the article "Novo/Nova", the possessive "os meus / as
// minhas", and the adjectives "aprovado/aprovada", "rejeitado/rejeitada" — cannot
// be composed safely across wordings, so they are stored as whole overridable
// phrases.
const env = import.meta.env

const singular = env.VITE_INVOICE_REQUESTS_LABEL || 'Pedido de Factura'
const plural = env.VITE_INVOICE_REQUESTS_LABEL_PLURAL || 'Pedidos de Factura'
const short = env.VITE_INVOICE_REQUESTS_LABEL_SHORT || 'Pedido'

const lower = singular.toLowerCase()
const lowerPlural = plural.toLowerCase()
const sentenceCase = (s) => s.charAt(0).toUpperCase() + s.slice(1)

export const invoiceRequestLabels = {
  // Title-case forms.
  singular, // "Pedido de Factura" — <h2>, edit-route title
  plural, // "Pedidos de Factura" — nav, list title/breadcrumb, module toggle
  newSingular: env.VITE_INVOICE_REQUESTS_LABEL_NEW || 'Novo Pedido de Factura', // new <h2>/title
  newShort: env.VITE_INVOICE_REQUESTS_LABEL_NEW_SHORT || 'Novo Pedido', // list "new" button, breadcrumb
  short, // "Pedido" — edit breadcrumb

  // Lower-case / sentence-case forms (derived — safe for both wordings, accents incl.).
  lower, // "pedido de factura" — bell count singular, "Mensagem sobre …", tooltips
  lowerPlural, // "pedidos de factura" — bell count plural, ACL help, "Actividade de …"
  sentencePlural: sentenceCase(lowerPlural), // "Pedidos de factura" — notif group title, "… pendentes"

  // Short, lower-case noun for the generic list (search placeholder "pesquisar …",
  // empty state "Sem …", export filename). The plural can't be derived from the
  // singular (Portuguese -ão→-ões), so it's the head word of `plural`.
  shortLower: short.toLowerCase(), // "pedido" / "comunicação"
  shortPluralLower: plural.split(' ')[0].toLowerCase(), // "pedidos" / "comunicações"

  // Verb form — cost-center "request" shortcut button.
  verb: env.VITE_INVOICE_REQUESTS_VERB || 'Pedir Factura',

  // Settings fieldset legend (its own phrasing in the default wording).
  settingsLegend: env.VITE_INVOICE_REQUESTS_SETTINGS_LEGEND || 'Pedidos de Emissão de Factura',

  // Gendered notification sentences — stored whole (article/adjective agreement).
  notifDecision:
    env.VITE_INVOICE_REQUESTS_LABEL_DECISION || 'Decisões sobre os meus pedidos de factura',
  notifApproved: env.VITE_INVOICE_REQUESTS_LABEL_APPROVED || 'Pedido de factura aprovado',
  notifRejected: env.VITE_INVOICE_REQUESTS_LABEL_REJECTED || 'Pedido de factura rejeitado',
}
